/**
 * apps/web :: pass :: screens/PostTripChecklist
 *
 * Phase-3 checklist — what to do after you're home (ROADS-569 W1.C4).
 * Thin wrapper over ChecklistScreen with phase="post". The eyebrow nudges
 * travelers to check official portals and pay inside the discount window,
 * the most expensive trap once the trip is over.
 */
import ChecklistScreen from "./ChecklistScreen";

export default function PostTripChecklist(): JSX.Element {
  return (
    <ChecklistScreen
      phase="post"
      eyebrow="Phase 3 · Check official portals · pay in the discount window"
      title="Post-trip checklist"
      accent="text-amber-600"
    />
  );
}
